import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPhotos, deletePhoto } from "../../lib/firebase/firestore";
import { Photo } from "../../types";

export const PhotoGalleryListPage = () => {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPhotos = async () => {
      try {
        const data = await getPhotos();
        setPhotos(data);
      } catch (error) {
        console.error("Failed to load photos:", error);
      } finally {
        setLoading(false);
      }
    };
    loadPhotos();
  }, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this photo?")) return;

    try {
      await deletePhoto(id);
      setPhotos((prev) => prev.filter((p) => p.id !== id));
      alert("Photo deleted successfully!");
    } catch (error) {
      console.error("Error deleting photo:", error);
      alert("Failed to delete photo");
    }
  };

  if (loading) return <div>Loading photos...</div>;

  return (
    <div style={{ padding: "2rem" }}>
      <h2 style={{ marginBottom: "1rem", color: "#333" }}>📸 Photo Gallery</h2>

      <Link
        to="/admin/photos/new"
        style={{
          display: "inline-block",
          marginBottom: "1.5rem",
          backgroundColor: "#007bff",
          color: "white",
          padding: "0.5rem 1rem",
          borderRadius: "6px",
          textDecoration: "none",
          fontWeight: "500",
        }}
      >
        ➕ Add New Photo
      </Link>

      {photos.length === 0 ? (
        <p>No photos added yet.</p>
      ) : (
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {photos.map((photo) => (
            <li
              key={photo.id}
              style={{
                border: "1px solid #eee",
                borderRadius: "8px",
                padding: "1rem",
                marginBottom: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#fafafa",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <img
                  src={photo.imageUrl}
                  alt={photo.title}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                  }}
                />
                <div>
                  <h3 style={{ margin: 0 }}>{photo.title}</h3>
                  {photo.year && (
                    <small style={{ color: "#777" }}>Year: {photo.year}</small>
                  )}
                </div>
              </div>

              <div style={{ display: "flex", gap: "0.75rem" }}>
                <Link
                  to={`/admin/photos/edit/${photo.id}`}
                  style={{
                    background: "#ffc107",
                    color: "#000",
                    padding: "0.4rem 0.8rem",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontWeight: "500",
                  }}
                >
                  ✏️ Edit
                </Link>
                <button
                  onClick={() => handleDelete(photo.id)}
                  style={{
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    padding: "0.4rem 0.8rem",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                >
                  🗑️ Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
